import axios from "axios"; // 引入axios
import apiList from "./api"; // 引入API列表
import Vue from "vue";
import router from "../router/index";
import store from "../store/index";
const CryptoJS = require("crypto-js"); //引用加密源码js
const vueObject = new Vue({});

axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// service 循环遍历输出不同的请求方法
let instance = axios.create({
  baseURL: store.state.config.baseURLJinShui,

  timeout: 60000
});

function guid() {
  return "xxxxxxxxxxxxxxxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
// console.log(guid())

const Http = {}; //抱过请求方法的容器
// console.log(apiList)
let requestParams;
// 请求格式/参数的统一
for (let key in apiList) {
  let api = apiList[key]; // url
  // console.log(api)
  // console.log(key)

  Http[key] = async function(
    params, // 请求参数 get:url,put,post,patch(data),delete:url
    isFormData = false, //标识是否是 form-data请求
    config = {} //配置参数
  ) {
    if (api.config) {
      config = api.config;
    }

    config.headers = config.headers ? config.headers : {};

    var userInfo = vueObject.$store.getters.getUserInfo;
    if (userInfo != false) {
      config.headers.token = userInfo.token;
      // config.headers.timestamp = parseInt(Date.parse(new Date()) / 1000);
      config.headers.timestamp = "";
      config.headers.sign = "";
      config.headers.userId = userInfo.userId;
    }

    let newParams = {};
    // content-type 是否是form-data
    if (params && isFormData) {
      // form-data转换
      newParams = new FormData();
      for (var i in params) {
        if (typeof params[i] == "array") {
          var osnParams = {},
            osnParams = new FormData();
          for (let j in params[i]) {
            osnParams.append(j, params[i][j]);
          }
          newParams.append(i, osnParams);
        } else {
          newParams.append(i, params[i]);
        }
      }
    } else {
      newParams = params;
    }
    // console.log(newParams)
    requestParams = newParams;

    config.isFormData = isFormData;
    config.signParam = params;

    // 不同请求的判断
    let response = {}; //请求的返回值
    if (
      api.method === "put" ||
      api.method === "post" ||
      api.method === "patch"
    ) {
      config.data = true;
      // put，post,patch请求
      // config.params = newParams

      try {
        response = await instance[api.method](api.url, newParams, config);
      } catch (err) {
        response = err;
      }
    } else if (api.method === "delete" || api.method === "get") {
      config.data = true;
      // delete,get请求
      config.params = newParams;

      try {
        response = await instance[api.method](api.url, config);
      } catch (err) {
        response = err;
      }
    }

    return response;
  };
}

// 请求拦截器的添加
instance.interceptors.request.use(
  (config) => {
    // console.log(config,11)

    // sign 验证
    // let appKey = "shuangan20200417";

    let appKey = "a4ccbdd350e5bcb4db657d122114b937";
    let privateKey = "zfb2e100753b68a04b6117829fd6c4dcel8d01a7c4b5e99909258a3e6e8506ec04f";
    var timestamp = parseInt(Date.parse(new Date()) / 1000);
    let nonce = guid();
    // console.log(timestamp,nonce)
    let sign = appKey + JSON.stringify(timestamp) + nonce + privateKey;
    // console.log(sign, 111)
    sign = CryptoJS.MD5(sign).toString();

    let param = config.signParam;
    let isFormData = config.isFormData;
    let paramKey = [];
    // let sign = "";
    // console.log(param)
    // console.log(JSON.stringify(param)+1)
    // console.log(typeof param)
    // console.log(Array.isArray(param))
    // return
    if (typeof param == "object" && !Array.isArray(param)) {
      //  console.log(2)
      if (param != null && param != undefined && param != "") {
        var arr = [];
        param = Object.assign({}, param);
        for (var i in param) {
          arr.push(i);
        }
        // console.log(arr)
        paramKey = arr.sort();
        // console.log(paramKey)
      }
      // if ()
      // // 判断是否有参数
      if (paramKey.length > 0 && !isFormData) {
        // sign = "";
        let paramString = JSON.stringify(param);
        // console.log(paramString,1111);
        paramString = paramString.replace(/\s+/g, "").replace("s*|\t|\r|\n/g", "");
        // console.log(paramString);
        // sign = appKey + paramString;
      }
      // console.log(config.method == "get")
      if ((paramKey.length > 0 && isFormData) || config.method == "get") {
        // sign = "";
        paramKey.forEach((element) => {
          // console.log(element)
          // console.log(param)
          if (element != "file") {
            // sign = sign + param[element].toString();
          }
        });
        // sign = sign + appKey;
        // console.log(param[paramKey])
        // console.log(111)
      }
    }
    // if (Array.isArray(param)) {
    //   sign = appKey + JSON.stringify(param);
    // }
    // if (!param) {
    //   sign = sign + appKey;
    // }
    // var localTime2 = parseInt(Date.parse(new Date()) / 1000);
    // // let nonce = guid();
    // var localTime1 = sessionStorage.getItem('localTime1');
    // var serverTime = sessionStorage.getItem('serverTime');
    // // console.log(localTime1,localTime2,serverTime)
    // var timeStamp = Number(localTime2) - Number(localTime1) + Number(serverTime);
    // console.log(timeStamp)
    // sign = sign + timeStamp;
    // console.log(sign)
    // sign = CryptoJS.MD5(sign);

    // console.log(param,222222)

    // var userInfo = vueObject.$store.getters.getUserInfo;
    // if (userInfo != false) {
    //   config.headers.token = userInfo.token;
    //   config.headers.timestamp = timeStamp;
    //   config.headers.sign = sign;
    //   config.headers.nonce = nonce;
    //   // config.headers.userId = userInfo.userId;
    // }
    config.headers.key = appKey;
    config.headers.timestamp = timestamp;
    config.headers.nonce = nonce;
    config.headers.sign = sign;

    return config;
  },
  (error) => {
    console.log("请求错误");
    console.log(error);
    // 请求错误
    vueObject.$message("网络不稳定，请稍后重试！");
  }
);

// 响应拦截器
instance.interceptors.response.use(
  async (res) => {
    if (res.data.code == 1001) {
      vueObject.$message("登录已过期，请重新登录！");
      router.replace("/login");
      setTimeout(() => {
        // window.location.reload();
        sessionStorage.clear();
      }, 50);
      return;
    }
    if (res.data.code == 1002) {
      vueObject.$message("请您正确操作！");
      return;
    }
    if (res.data.code == 1003) {
      vueObject.$message("请求时，您的时间戳不能为空");
      return;
    }
    if (res.data.code == 1004) {
      vueObject.$message("请求超时，请更新本地电脑时间,并重启浏览器！");
      return;
    }
    if (res.data.code == 1005) {
      vueObject.$message("请勿频繁操作！");
      return;
    }
    if (res.data.code == 1006) {
      vueObject.$message("请刷新页面后再操作！");
      return;
    }
    if (res.data.code == 1007) {
      vueObject.$message("该用户已被禁用！");
      router.replace("/login");
      setTimeout(() => {
        // window.location.reload();
        sessionStorage.clear();
      }, 50);
      return;
    }

    //请求成功
    if (typeof res.data == "string") {
      return res;
    }
    res.data.responseData = res;

    return res.data;
  },
  (error) => {
    console.log("响应错误");
    console.log(error);
    // 响应失败
    vueObject.$message("网络不稳定，请重试！");
  }
);

export default Http;
